import api, { Paginated } from '.'
import { IArticle } from './interfaces/IArticle'
import {
  IBaseBodyComment,
  IBaseCommentRO,
  IPaginateComment,
} from './interfaces/IComment'

export const ArticleApi = (accessToken?: string) => ({
  get: async (id: number) => {
    const res = await api.get<IArticle.IArticleDetailRO>(`/articles/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  getEdit: async (id: number) => {
    const res = await api.get<IArticle.IArticleDetailRO>(
      `/articles/${id}/edit-request`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )

    return res.data
  },

  create: async (body: IArticle.IArticleCreate) => {
    const res = await api.post('/articles', body, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  update: async (id: number, body: IArticle.IArticleCreate) => {
    const res = await api.patch(`/articles/${id}`, body, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  delete: async (id: number) => {
    const res = await api.delete(`/articles/${id}/request`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  paginate: async (params: IArticle.IPaginate) => {
    const res = await api.get<IArticle.IPaginateRO>('/articles', {
      params,
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  savePaginate: async (username: string, params: IArticle.ISavePaginate) => {
    const res = await api.get<IArticle.ISavePaginateRO>(
      `/users/${username}/profile/save/article`,
      {
        params,
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )

    return res.data
  },

  monthlyHotIssuePaginate: async () => {
    const res = await api.get<IArticle.IMonthlyHotIssuePaginateRo[]>(
      '/articles/monthly-hot-issue/list',
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
    return res.data
  },

  paginateComment: async (articleId: number, params: IPaginateComment) => {
    const res = await api.get<Paginated<IBaseCommentRO>>(
      `/articles-comment/${articleId}`,
      {
        params,
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
    return res.data
  },

  likeComment: async (commentId: number) => {
    const res = await api.post<boolean>(`/articles-comment/${commentId}/like`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  deleteComment: async (commentId: number) => {
    const res = await api.delete<boolean>(`/articles-comment/${commentId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  updateComment: async (commentId: number, body: IBaseBodyComment) => {
    const res = await api.patch<IBaseCommentRO>(
      `/articles-comment/${commentId}`,
      body,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
    return res.data
  },

  createComment: async (articleId: number, body: IBaseBodyComment) => {
    const res = await api.post<IBaseCommentRO>(
      `/articles-comment/${articleId}`,
      body,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
    return res.data
  },

  categories: async () => {
    const res = await api.get<IArticle.ICategoriesRO[]>('/articles/categories')
    return res.data
  },

  bookmark: async (articleId: number) => {
    const res = await api.post<boolean>(`/articles-bookmark/${articleId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },

  reaction: async (id: number, body: IArticle.IReaction) => {
    const res = await api.post<IArticle.IReactionRO>(
      `/articles/${id}/reaction`,
      body,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )

    return res.data
  },

  view: async (id: number) => {
    const res = await api.post<number>(`/articles/${id}/view`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return res.data
  },
})
